import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';

import AuthBootstrap from '@/components/common/AuthBootstrap';
import { ToastProvider } from '@/components/ui';
import AppRouter from '@/routes/AppRouter';
import { store } from '@/store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthBootstrap>
          <AppRouter />
        </AuthBootstrap>
      </ToastProvider>
    </QueryClientProvider>
  </Provider>
);

export default App;
